import { FC } from 'react'
import { useHistory } from 'react-router-dom'

import { GoBackHeaderBtn, GoBackHeaderContainer } from './styles'

interface GoBackHeaderProps {
  icon?: string
  onClick?: () => void
  text?: string
}

const GoBackHeader: FC<GoBackHeaderProps> = ({
  icon = 'arrow-left',
  onClick,
  text = 'Go back'
}) => {
  const history = useHistory()

  const handleClick: typeof onClick = () => {
    if (onClick) return onClick()
    history.goBack()
  }

  return (
    <GoBackHeaderContainer onClick={handleClick}>
      <GoBackHeaderBtn>
        <span
          className={`mdi mdi-${icon} mdi-18px`}
          data-testid='goback-header-span'
        />
        <p>{text}</p>
      </GoBackHeaderBtn>
    </GoBackHeaderContainer>
  )
}

export default GoBackHeader
